export const ALLOWED_EXTENSIONS = ['.parquet', '.zip', '.tar.gz'];

export function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function validateFileExtension(file, allowed = ALLOWED_EXTENSIONS) {
  if (!file) return false;
  return allowed.some(ext => file.name.toLowerCase().endsWith(ext));
}

export function getFileMetadata(file) {
  if (!file) return { fullFileName: '', fileExtension: '', size: 0 };
  
  const fullFileName = file.name;
  const fileExtension = fullFileName.split('.').pop();
  
  return { 
    fullFileName, 
    fileExtension,
    size: file.size 
  };
}